import React from 'react';
import { useParams } from 'react-router-dom';
import { CONTRACT_ACTIONS, ContractActions } from '../contract-actions';

const ContractHeaderHistoryVersionActions = () => {
  const { contractHeaderId, versionNumber } = useParams();

  return (
    <ContractActions
      actions={[
        CONTRACT_ACTIONS.BACK_TO_CONTRACT_HISTORY,
        CONTRACT_ACTIONS.VIEW_CONTRACT_VERSION_LISTING,
        CONTRACT_ACTIONS.VIEW_LATEST_CONTRACT_VERSION,
      ]}
      contractHeaderId={contractHeaderId}
      versionNumber={versionNumber}
    />
  );
};

export default ContractHeaderHistoryVersionActions;
